import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { localize } from 'react-localize-redux';

import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';

import { languageMapping } from 'helpers/constants';

export const LanguageDropDown = ({
  open,
  anchorEl,
  handleLanguageChange,
  handleClose,
  defaultLanguages,
}) => {
  if (!defaultLanguages || defaultLanguages.length === 0 || defaultLanguages.length === 1)
    return null;

  const languages = defaultLanguages.map((language) => {
    return (
      <MenuItem
        onClick={handleClick}
        value={language}
        aria-label={languageMapping[language]}
        key={language}
        tabIndex={0}
      >
        {languageMapping[language]}
      </MenuItem>
    );
  });

  return (
    <Popper open={open} anchorEl={anchorEl} transition disablePortal placement="left-end">
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          id="lang-menu-list-grow"
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>{languages}</Paper>
        </Grow>
      )}
    </Popper>
  );

  function handleClick(e) {
    handleLanguageChange(e.target.attributes.value.value);
    localStorage.setItem('locale', e.target.attributes.value.value);
    handleClose();
  }
};

export default localize()(LanguageDropDown);
